/**
 * Prefix for files in `public/` when the app is built with a non-root `homepage` / `PUBLIC_URL`.
 */
export function publicUrl(path) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}

/**
 * Same asset as `publicUrl`, but an absolute URL on the current origin. Use for `<video src>` / `<audio src>`
 * so playback still works if the page has a `<base href>` (e.g. some Shopify embeds) or odd relative resolution on production.
 */
export function publicAbsoluteUrl(path) {
  const rel = publicUrl(path);
  if (typeof window === 'undefined') return rel;
  if (/^https?:\/\//i.test(rel)) return rel;
  try {
    return new URL(rel, window.location.href).href;
  } catch {
    return rel;
  }
}
